import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { catalogCreateWorkType } from '../catalogTypesWorkQuery';

interface IUseCreateTypeWork {
    onSuccessHandler: () => void;
}

export const useCreateTypeWork = ({ onSuccessHandler }: IUseCreateTypeWork) => {
    const [createTypeWorkData, createTypeWorkStatus, createTypeWorkError, createTypeWorkRequest] = useRequest({
        requestId: 'createTypeWork',
        query: catalogCreateWorkType,
        withEffect: false,
        dependenciesUpdater: onSuccessHandler,
    });
    const [resetCreatingData] = useResetStoreData({ requestId: 'createTypeWork' });

    const isCreatingInProgress = createTypeWorkStatus === RequestStatus.FETCHING;

    return {
        createTypeWorkData: createTypeWorkData?.catalogCreateWorkType,
        createTypeWorkStatus,
        createTypeWorkError,
        createTypeWorkRequest,
        resetCreatingData,
        isCreatingInProgress,
    };
};
